import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import { useUser } from "./Provider/UserProvider";
import "./Component/Asset.css";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { OrganizationMemberSelectBox } from "./Component/OrganizationMemberSelectBox";
import { Grid } from "@mui/material";
import Modal from "./Component/Modal";
import { API_DOMAIN_URL } from "./Common";
import TextField from "@mui/material/TextField";
import { OwnedGroupSelectBox2 } from "./Component/OwnedGroupSelectBox2";

export function ImportJDCMembersCsv() {
  const navigate = useNavigate();
  const { user } = useUser();
  const [organizationUsers, setOrganizationUsers] = useState(null);
  const [orgUser, setOrgUser] = useState();
  const [OwnerGroupId, setOwnerGroupId] = useState("");
  const [ownedGroups, setOwnedGroups] = useState();
  const [targetGroup, setTargetGroup] = useState();

  const authCheck = () => {
    if (!user || !user.id || user.id == "error") {
      navigate("/SignIn");
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (authCheck()) {
      getOrganizationUsers();
    }
  }, []);

  useEffect(() => {
    if (user && user.id) {
      getOwnedGroups(user);
    }
  }, []);

  const getOwnedGroups = (orgUser) => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/GetOwnedGroups?code=${code}&UserId=${orgUser.id}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        setOwnedGroups(response);
      })
      .catch(() => {
        setOwnedGroups([orgUser]);
      });
  };

  const getOrganizationUsers = () => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetOrganizationUsers?code=${code}&UserId=${user.id}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        //response.push(user);
        setOrganizationUsers(response);
      })
      .catch(() => {
        //console.error();
        console.log("ImportJDCMembersCsv OrganizationUsers Exception");
        let orgUsers = [];
        orgUsers.push(user);
        setOrganizationUsers(orgUsers);
      });
  };

  const csvparse = (text, orgUserId) => {
    try {
      let finalObj = {};
      let memberAry = [];

      let recordAry = text.split("\r\n");
      recordAry.forEach((record) => {
        let cells = record.split(",");

        if (cells.length >= 10) {
          let addingMember = {};
          addingMember.UserName = cells[0];
          addingMember.Password = cells[1];
          addingMember.NickName = cells[2];
          addingMember.Furigana = cells[3];
          addingMember.MailAddress = cells[4];
          if (cells[5] == "男") {
            addingMember.Sex = 1;
          } else if (cells[5] == "女") {
            addingMember.Sex = 2;
          } else {
            addingMember.Sex = parseInt(cells[5]);
          }
          addingMember.Birthday = cells[6];
          addingMember.Group1 = cells[7];
          addingMember.Group2 = cells[8];
          addingMember.Group3 = cells[9];
          addingMember.CreateUserId = orgUserId;

          console.log(addingMember.Group3);
          memberAry.push(addingMember);
        }
      });

      finalObj.Members = memberAry;
      return finalObj;
    } catch {
      return false;
    }
  };

  const uploadCsv = (bodyObj) => {
    let jsonString = JSON.stringify(bodyObj);

    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/Rp_CreateJDCSubMember?code=${code}&OwnerGroupId=${targetGroup.id}`;
    console.log(url);
    console.log(jsonString);

    fetch(url, {
      method: "POST",
      body: jsonString,
    }).then(
      function (response) {
        //console.log("response" + response);
        if (response.status == 200) {
          successModalOpen();
        } else if (response.status == 204 || response.status == 400) {
          //console.log(response.status);
          errorModalOpen();
        }
      },
      function (error) {
        console.log(error);
        errorModalOpen();
      }
    );
  };

  const fileUpload = () => {
    //console.log(orgUser);
    const file = document.getElementById("csvFile").files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      //console.log(e.target.result);
      let obj = csvparse(e.target.result, orgUser.id);
      if (obj && obj.Members && obj.Members.length >= 1) {
        uploadCsv(obj);
      } else {
        errorModalOpen();
      }
    };

    if (file) {
      reader.readAsText(file, "shift-jis");
    }
  };

  /*  const downloadFromUrlAutomatically = (url, fileName) => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function (e) {
      if (this.status == 200) {
        var urlUtil = window.URL || window.webkitURL;
        var imgUrl = urlUtil.createObjectURL(this.response);
        var link = document.createElement("a");
        link.href = imgUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      console.log(e);
    };
    xhr.send();
  };*/

  const sampleFileDownload = () => {
    //console.log(OwnerGroupId);
    // downloadFromUrlAutomatically(
    //  "https://devseniorquality8937.blob.core.windows.net/sample/sample.csv",
    //  "sample.csv"
    // );
  };

  // 更新完了確認のモーダル
  const [successModalStatus, setSuccessModalStatus] = React.useState(false);
  const successModalOpen = () => {
    setSuccessModalStatus(true);
  };
  const successModalClose = () => {
    setSuccessModalStatus(false);
  };

  // エラーモーダル
  const [errorModalStatus, setErrorModalStatus] = React.useState(false);
  const errorModalOpen = () => {
    setErrorModalStatus(true);
  };
  const errorModalClose = () => {
    setErrorModalStatus(false);
  };

  const commonStyles = {
    bgcolor: "background.paper",
    border: 1,
    borderColor: "#bdbdbd",
  };

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={12}>
              <Typography component="h1" variant="h5">
                CSVファイル取り込み
              </Typography>
            </Grid>

            <Grid item md={12} mt={1}>
              <Typography variant="body2">アップロード先</Typography>
              <OrganizationMemberSelectBox
                orgUsers={organizationUsers}
                setOrgUser={setOrgUser}
                setShowAddBtn={null}
              />
            </Grid>

            <Grid item md={12} mt={2}>
              <OwnedGroupSelectBox2
                ownedGroups={ownedGroups}
                setTargetGroup={(e) => {
                  setTargetGroup(e);
                  setOwnerGroupId(e.id);
                  console.log(e.id);
                }}
              />
            </Grid>

            <Grid item md={12}>
              <TextField
                size="small"
                fullWidth
                name="OwnerGroupId"
                label="管理者グループID"
                id="OwnerGroupId"
                value={OwnerGroupId}
                onChange={(e) => setOwnerGroupId(e.target.value)}
              />
            </Grid>

            <Grid item md={9} mt={1}></Grid>
            <Grid item md={12} mt={1}>
              <Typography variant="body2">
                CSVファイルを選択してください
              </Typography>
              <input type="file" accept=".csv" id="csvFile" />
            </Grid>
            <Button
              variant="contained"
              color="success"
              sx={{ mt: 2 }}
              align
              onClick={() => fileUpload()}
            >
              CSV読み込み
            </Button>
          </Grid>
        </Box>
        <Grid
          container
          direction="coloum"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ ...commonStyles, p: 2, mt: 2 }}
        >
          <Grid item md={12}>
            <Typography variant="body2">
              CSVフォーマットデータ（サンプル）のダウンロード
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Button
              variant="contained"
              color="primary"
              sx={{ pr: "50px", pl: "50px" }}
              onClick={() => sampleFileDownload()}
            >
              サンプルのダウンロード
            </Button>
          </Grid>
          <Grid item md={12}>
            <Typography variant="body2">
              ◆ヘッダーとなる１列目は、変更しないようにご注意ください。
            </Typography>
          </Grid>
          <Grid item md={12} mt={2}>
            <Typography variant="h6">項目の説明</Typography>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid item md={2}>
              <Typography variant="body2">列Ａ 名前</Typography>
            </Grid>
            <Grid item md={10}>
              <Typography variant="body2">
                ▸
                メンバーの表示名（入力が無ければエラーとなり、CSVの取り込みに失敗します）
              </Typography>
            </Grid>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｂ ふりがな</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ ひらがなで入力してください
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｃ 性別</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ 男の場合1，または女の場合は2（何も入力しなければ男になります）
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｄ 誕生日</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ 例：昭和45.01.01&nbsp;または&nbsp;1970.01.01
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｅ 身長 cm</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ 小数点以下第１位まで入力可能です
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｆ 体重 kg</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸ 小数点以下第１位まで入力可能です
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｇ 都道府県</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸
              施設が所在する都道府県を入力してください（何も入力しなければ北海道になります）
            </Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｈ 郵便番号</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">▸ ７ケタの数字ハイフンなし</Typography>
          </Grid>

          <Grid item md={2}>
            <Typography variant="body2">列Ｉ 介護度</Typography>
          </Grid>
          <Grid item md={10}>
            <Typography variant="body2">
              ▸
              事業対象者、要支援１、要支援２、要介護１、要介護２、要介護３、要介護４、要介護５&nbsp;など
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Modal
        title={"登録失敗"}
        message={"CSVによるメンバー登録に失敗しました"}
        status={errorModalStatus}
        okBtnCallback={errorModalClose}
      />
      <Modal
        title={"登録成功"}
        message={"CSV読み込みによる登録が完了しました"}
        status={successModalStatus}
        okBtnCallback={successModalClose}
      />
    </div>
  );
}
